import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame, ArrowRight } from "lucide-react";
import api, { money, assetUrl } from "@/lib/api";
import { ConditionBadge } from "@/components/ConditionBadge";

export function BestSellersRow() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/products/best-sellers?limit=6").then((r) => setData(r.data)).catch(() => setData({ products: [] }));
  }, []);

  if (!data || !data.products?.length) return null;

  const label = data.window_days <= 7 ? "This week"
    : data.window_days <= 30 ? "This month"
    : "Recent bestsellers";

  return (
    <section className="border-b-2 border-ink bg-surface" data-testid="best-sellers-row">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-6">
        <div className="flex items-baseline justify-between mb-4">
          <div className="flex items-center gap-3">
            <Flame className="h-5 w-5 text-danger" />
            <h2 className="font-heading font-black text-xl sm:text-2xl tracking-tighter">MOST BOUGHT · {label.toUpperCase()}</h2>
          </div>
          <Link to="#catalog" className="font-mono text-[11px] uppercase tracking-wider text-subtle hover:text-ink transition-colors hidden sm:inline-flex items-center gap-1">
            Browse all <ArrowRight className="h-3 w-3" />
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
          {data.products.map((p) => (
            <Link
              key={p.id}
              to={`/product/${p.id}`}
              data-testid={`best-seller-${p.id}`}
              className="group border-2 border-ink bg-paper hover:-translate-y-0.5 hover:shadow-hard transition-all"
            >
              <div className="aspect-square bg-surface border-b-2 border-ink overflow-hidden relative">
                {p.images?.[0] ? (
                  <img src={assetUrl(p.images[0])} alt={p.name} className="h-full w-full object-cover group-hover:scale-105 transition-transform" />
                ) : (
                  <div className="h-full w-full flex items-center justify-center text-subtle font-mono text-xs">No image</div>
                )}
                <span className="absolute top-1 left-1 bg-ink text-paper font-mono text-[9px] uppercase tracking-wider px-1.5 py-0.5">
                  #{p.units_sold} sold
                </span>
              </div>
              <div className="p-2">
                <div className="font-heading font-bold text-xs leading-tight line-clamp-2 min-h-[2rem]">{p.name}</div>
                <div className="mt-1 flex items-baseline justify-between gap-1">
                  <span className="font-heading font-black text-sm">{money(p.our_price)}</span>
                  {p.list_price > p.our_price && (
                    <span className="font-mono text-[10px] text-subtle line-through">{money(p.list_price)}</span>
                  )}
                </div>
                <div className="mt-1"><ConditionBadge condition={p.condition} /></div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
